(() => {
  const notice = document.createElement('section');
  notice.className = 'glass-cart-notice';
  notice.setAttribute('aria-label', 'Cart confirmation');
  notice.hidden = true;
  notice.innerHTML = '<div class="glass-notice-heading"><span class="glass-notice-check" aria-hidden="true">✓</span><strong>Added to your bag</strong><button type="button" class="glass-notice-close" aria-label="Dismiss cart confirmation">×</button></div><p class="glass-notice-message" role="status" aria-live="polite" aria-atomic="true"></p><button type="button" class="button glass-notice-view">View cart <span aria-hidden="true">↗</span></button>';
  document.body.append(notice);
  const message = notice.querySelector('.glass-notice-message');
  let timer, announceTimer, returnFocus;
  const schedule = () => {
    clearTimeout(timer);
    if (!notice.hidden && !notice.matches(':hover') && !notice.contains(document.activeElement)) timer = setTimeout(hide, 8000);
  };
  function hide() {
    clearTimeout(timer); clearTimeout(announceTimer);
    const hadFocus = notice.contains(document.activeElement);
    notice.hidden = true;
    if (hadFocus && returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  }
  notice.querySelector('.glass-notice-close').addEventListener('click', hide);
  notice.querySelector('.glass-notice-view').addEventListener('click', () => {
    hide(); document.querySelector('#cart-open').click();
  });
  notice.addEventListener('pointerenter', () => clearTimeout(timer));
  notice.addEventListener('pointerleave', schedule);
  notice.addEventListener('focusin', () => clearTimeout(timer));
  notice.addEventListener('focusout', () => setTimeout(schedule, 0));
  document.addEventListener('keydown', event => { if(event.key === 'Escape' && !notice.hidden) hide(); });
  document.querySelector('#cart-open').addEventListener('click', hide);
  window.HeirloomCartNotice = {
    show(item, quantity) {
      clearTimeout(timer); clearTimeout(announceTimer);
      if (!notice.contains(document.activeElement)) returnFocus = document.activeElement;
      const title = item.product_title || item.title || 'Item';
      const pack = item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '';
      message.textContent = '';
      notice.hidden = false;
      announceTimer = setTimeout(() => { message.textContent = title + pack + ' · Quantity ' + quantity; }, 30);
      schedule();
    }
  };
})();
